/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DiscoverVersionsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DiscoverVersionsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DiscoverVersionsSecurity = {
  option1?: DiscoverVersionsSecurityOption1 | undefined;
  option2?: DiscoverVersionsSecurityOption2 | undefined;
};

export type DiscoverVersionsRequest = {
  includeDeleted?: boolean | undefined;
  /**
   * Unsupported: any supplied value returns 400
   */
  updatedSince?: string | undefined;
  serverName: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DiscoverVersionsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DiscoverVersionsSecurityOption1$outboundSchema: z.ZodMiniType<
  DiscoverVersionsSecurityOption1$Outbound,
  DiscoverVersionsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function discoverVersionsSecurityOption1ToJSON(
  discoverVersionsSecurityOption1: DiscoverVersionsSecurityOption1,
): string {
  return JSON.stringify(
    DiscoverVersionsSecurityOption1$outboundSchema.parse(
      discoverVersionsSecurityOption1,
    ),
  );
}

/** @internal */
export type DiscoverVersionsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DiscoverVersionsSecurityOption2$outboundSchema: z.ZodMiniType<
  DiscoverVersionsSecurityOption2$Outbound,
  DiscoverVersionsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function discoverVersionsSecurityOption2ToJSON(
  discoverVersionsSecurityOption2: DiscoverVersionsSecurityOption2,
): string {
  return JSON.stringify(
    DiscoverVersionsSecurityOption2$outboundSchema.parse(
      discoverVersionsSecurityOption2,
    ),
  );
}

/** @internal */
export type DiscoverVersionsSecurity$Outbound = {
  Option1?: DiscoverVersionsSecurityOption1$Outbound | undefined;
  Option2?: DiscoverVersionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DiscoverVersionsSecurity$outboundSchema: z.ZodMiniType<
  DiscoverVersionsSecurity$Outbound,
  DiscoverVersionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DiscoverVersionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DiscoverVersionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function discoverVersionsSecurityToJSON(
  discoverVersionsSecurity: DiscoverVersionsSecurity,
): string {
  return JSON.stringify(
    DiscoverVersionsSecurity$outboundSchema.parse(discoverVersionsSecurity),
  );
}

/** @internal */
export type DiscoverVersionsRequest$Outbound = {
  include_deleted: boolean;
  updated_since?: string | undefined;
  serverName: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DiscoverVersionsRequest$outboundSchema: z.ZodMiniType<
  DiscoverVersionsRequest$Outbound,
  DiscoverVersionsRequest
> = z.pipe(
  z.object({
    includeDeleted: z._default(z.boolean(), false),
    updatedSince: z.optional(z.string()),
    serverName: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      includeDeleted: "include_deleted",
      updatedSince: "updated_since",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function discoverVersionsRequestToJSON(
  discoverVersionsRequest: DiscoverVersionsRequest,
): string {
  return JSON.stringify(
    DiscoverVersionsRequest$outboundSchema.parse(discoverVersionsRequest),
  );
}
